export type DataGridColumnAlignmentType = 'start' | 'center' | 'end';

export interface TableColumnDef {
  text: string;
  name: string;
  sort?: boolean;
  sortFieldName?: string;
  width?: number;
  widthPercentage?: string;
  pipe?: any;
  pipeArgs?: any[];
  dataType?: FieldDataType;
  align?: DataGridColumnAlignmentType;
  isRowSpan?: boolean;
  renderAsHtml?: boolean;
}

export interface TableFooterRow {
  label: string;
  content: string;
  needExport: boolean;
  pipe?: any;
  pipeArgs?: any[];
  dataType?: FieldDataType;
}

export enum DataGridExportFileNames {
  DEFAULT = "ExportData",
  CUSTOMER = "Customers",
  ORDER = "Orders",
  INVENTORY_MOVEMENTS = "StockMovements",
  CTN_DISCREPANCY = "CtnDiscrepancy",
  CASH_SALES = "CashSales",
  MY_OPEN_INVOICES = "MyOpenInvoices",
  CUSTOMER_OPEN_INVOICES = "CustomerOpenInvoices",
  MATERIAL_MOVEMENT = 'MaterialMovement',
  DELIVERY_LIST = 'DeliveryList',
  SHIPMENT_LIST = 'TripList',
  //SHIPMENT_DETAIL = 'TripDetail',
  CLOSED_ORDERS = 'ClosedOrders',
  //CLOSED_ORDER_LINEITEMS = 'closed-orders-lineitems',
  INVOICES = 'Invoices',
  INVOICES_DELIVERIES = 'InvoicesDeliveries',
  DELIVERIES = 'Deliveries',
  STOCK_ALLOCATION = 'StockAllocation'
}

export enum DataGridRowSize {
  BIG = "big",
  MEDIUM = "medium",
  SMALL = "small"
}

export const CHECKBOX_COLUMN_NAME = "select";

export enum FieldDataType {
  CURRENCY = "currency",
  TEXT = "text"
}
